module.exports = __webpack_public_path__ + "img/yxfw_sxbx.f58bfdd9.png";